// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d2ea031","455":"26d28bfa","977":"d09dc3ee"}[chunkId] + ".chunk.js";
};